
// Native SmoothScroll
( function() {
	// all "#" links (except the tabs that start with js- and empty #'s)
	var anchors = document.querySelectorAll( 'a[href^="#"]:not([href^="#js-"]):not([href="#"])' );

	[].forEach.call( anchors, function( anchor ) {
		anchor.addEventListener( 'click', function( e ) {

			e.preventDefault( );

			// Item that we're scrolling to.
			var anchoredItem = this.getAttribute( 'href' );

			// prevent running the same logic twice.
			if ( !document.querySelector( anchoredItem ).classList.contains( 'anchored-smooth-scroll' ) ) {

				// wpadminbar offset
				var adminbarTop = document.getElementById( 'wpadminbar' ) ? document.getElementById( 'wpadminbar' ).scrollHeight : 0;

				// site header offset
				var headerTop = 0;

				// make sure sticky menu is active before grabbing height.
				if ( document.body.classList.contains( 'menu-created_js-menu-primary-wrapper' ) && document.getElementById( 'banner' ) ) {
					headerTop = document.getElementById( 'banner' ).scrollHeight;
				}

				// default intial item padding
				var itemInitialPadding = document.querySelector( anchoredItem ).style.paddingTop ? parseFloat( document.querySelector( anchoredItem ).style.paddingTop, 10 ) : 0;

				var offset = headerTop + adminbarTop + itemInitialPadding;

				// add the offset to the anchored item.
				document.querySelector( anchoredItem ).setAttribute( 'style', 'padding-top:' + offset + 'px; margin-top: -' + offset + 'px;' );
				document.querySelector( anchoredItem ).classList.add( 'anchored-smooth-scroll' );
			}

			// scroll smoothly.
			document.querySelector( anchoredItem ).scrollIntoView( {
				behavior: 'smooth',
				block: 'start'
			} );
		} );
	} );
} )( );
